module.exports = __webpack_public_path__ + "img/valleint7.0e2b3492.png";